import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

/**
 * Saves the FCM token on the backend for push notifications
 * @param {string} token
 */
export async function saveFCMToken(token) {
  try {
    const response = await fetch(`${BASE_URL}insurance/save-fcm-token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      throw new Error("Error saving FCM token");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error saving FCM token:", error);
  }
}
